export default __webpack_public_path__ + "static/media/mina.c11be8fc.svg";